import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  height: {
    height: 35,
    wordBreak: "break-all",
    borderBottom: "1px solid #dedede",
    lineHeight: 2
  },
  noneBorder: {
    borderBottom: "none"
  }
});

function CustomMultiCell(props) {
  const { children, lastNode } = props;
  const classes = useStyles();

  const className = lastNode ? classes.noneBorder : "";

  return <div className={`${classes.height} ${className}`}>{children}</div>;
}

export default CustomMultiCell;
